import type { $Fetch } from 'ofetch';
import type { AlunoBloqueioAcesso } from '@/domain/model/AlunoBloqueioAcesso';
import type {
  AlunoBloqueioAcessoGateway, BloquearAcessoCommand, DesbloquearAcessoCommand,
} from '@/application/port/out/AlunoBloqueioAcessoGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpAlunoBloqueioAcessoGateway implements AlunoBloqueioAcessoGateway {
  constructor(private readonly client: $Fetch) {}

  async bloquear(c: BloquearAcessoCommand): Promise<AlunoBloqueioAcesso> {
    const res = await this.client<ApiResponse<AlunoBloqueioAcesso>>(
      `/api/v1/alunos/${encodeURIComponent(c.alunoId)}/bloqueios-acesso`,
      { method: 'POST', body: { motivo: c.motivo, bloqueadoAte: c.bloqueadoAte } });
    assertApiSuccess(res);
    return res.data;
  }

  async desbloquear(c: DesbloquearAcessoCommand): Promise<AlunoBloqueioAcesso> {
    const res = await this.client<ApiResponse<AlunoBloqueioAcesso>>(
      `/api/v1/alunos/bloqueios-acesso/${encodeURIComponent(c.bloqueioId)}/desbloquear`,
      { method: 'POST', body: { motivo: c.motivo } });
    assertApiSuccess(res);
    return res.data;
  }

  async listByAluno(alunoId: string): Promise<AlunoBloqueioAcesso[]> {
    const res = await this.client<ApiResponse<AlunoBloqueioAcesso[]>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/bloqueios-acesso`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async findAtivo(alunoId: string): Promise<AlunoBloqueioAcesso | null> {
    const res = await this.client<ApiResponse<AlunoBloqueioAcesso | null>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/bloqueio-acesso-ativo`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
